import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import FibersLobbyHeaderBlockData from 'app/Models/Content/FibersLobbyHeaderBlockData';
import React, {useState, useEffect} from 'react';
import {Container} from 'reactstrap'; 
import {useInView} from 'react-intersection-observer';
import classNames from 'classnames';
import {isMobile} from 'react-device-detect';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import MarketingBlockData from 'Models/Content/MarketingBlockData';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import TagName, {Tags} from 'app/Components/Shared/TagName';

const FibersLobbyHeaderBlock = ({data, context}: ComponentProps<FibersLobbyHeaderBlockData>) => {
  const {image, mobileImage, buttonLink, buttonLinkTitle} = data;
  const [ref, inView, entry] = useInView();
  const [sticky, setSticky] = useState(false);
  const [stickyIn, setStickyIn] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  var designModeNumber = -1;
  var designText = 'להצטרפות';

  if(data.buttonLinkTitle.value!=""){
    designText=data.buttonLinkTitle.value;
  }

  if (data.blockButton.value!=null) {
    designText = (data.blockButton.expandedValue[0] as any).text.value;
    designModeNumber = (data.blockButton.expandedValue[0] as any).buttonDesignMode.value;
  }

  useEffect(() => {
    if (!entry) return;
    if (!inView) {
      setSticky(true);
      setStickyIn(true);
    } else {
      setStickyIn(false);
      setTimeout(() => {
        setSticky(false);
      }, 300);
    }
  }, [inView, entry]);

  const fibersLobbyButtonClick = () => {
    setIsButtonLoading(true);
    if(buttonLink!=null)
    context.navigateTo(buttonLink.value);
  };
  
  
  const getButtonClassByName = (designIndex) => {
    let name = '';
    switch (designIndex) {
      case 0:
        name = 'purple-button';
        break;
      case 1:
        name = 'black-button';
        break;
      case 2:
        name = 'white-button';
        break;
      case -1:
        name = 'purple-button';
        break;
    }
  
    return name;
  };
  

return (
    <div className='FibersLobbyHeaderBlock' {...getBackgroundImageProps(isMobile ? mobileImage : image, context)}>
      <Container>
        <div className='FibersLobbyHeaderBlock__header'>
          <TagName className='FibersLobbyHeaderBlock__header__title' tagName={data.titleHeadlineTag?.value} isTitle>
            {!isMobile && data.desktopTitle?.expandedValue
              ? (data.desktopTitle.expandedValue[0] as MarketingTextBlockData).text.value
              : data.title.value}
          </TagName>
          <TagName className='FibersLobbyHeaderBlock__header__subtitle' tagName={data.subtitleHeadlineTag?.value}>
            {!isMobile && data.desktopSubtitle?.value ? data.desktopSubtitle.value : data.subtitle.value}
          </TagName>

          <div ref={ref} className='sticky-wrapper'>
            <div className={classNames('sticky-placeholder', {show: sticky})}></div>
            <div className={classNames('buttons-wrapper', {sticky: sticky, in: stickyIn})}>
              <button className={`lobby-button ${getButtonClassByName(designModeNumber)} ${isButtonLoading ? "loading" : ""}`} onClick={fibersLobbyButtonClick}>{designText} &#187;</button>
            </div>
          </div>
          <div className='FibersLobbyHeaderBlock__header__icons'>

          </div>
        </div>
      </Container>
    </div>
  );
};



export default FibersLobbyHeaderBlock;
